import { css } from "lit";

export const styles = css`
  .container {
    display: grid;
    height: 100dvh;

    grid-template:
      " menu  header" auto
      " menu  main  " 1fr
      / 15rem 1fr;
  }

  .menu {
    grid-area: menu;
    background: var(--sds-color-background-default-secondary);
  }

  page-header {
    grid-area: header;
  }

  .main {
    overflow: hidden;
    grid-area: main;
  }

  @media (max-width: 768px) {
    .container {
      grid-template:
        " header" auto
        " main  " 1fr
        " menu  " 4.5rem
        / 1fr;
    }

    .menu {
      height: 4.5rem;
      position: sticky;
      bottom: 0;
      z-index: 1;
    }
  }
`;
